import { TransliterationMethod, TransliterationRule } from './transliteration';

export class Transliterator {
  private ikaoRules: TransliterationRule[] = [
    { input: 'а', output: 'a' },
    { input: 'б', output: 'b' },
    { input: 'в', output: 'v' },
    { input: 'г', output: 'g' },
    { input: 'д', output: 'd' },
    { input: 'е', output: 'e' },
    { input: 'ё', output: 'e' },
    { input: 'ж', output: 'zh' },
    { input: 'з', output: 'z' },
    { input: 'и', output: 'i' },
    { input: 'й', output: 'i' },
    { input: 'к', output: 'k' },
    { input: 'л', output: 'l' },
    { input: 'м', output: 'm' },
    { input: 'н', output: 'n' },
    { input: 'о', output: 'o' },
    { input: 'п', output: 'p' },
    { input: 'р', output: 'r' },
    { input: 'с', output: 's' },
    { input: 'т', output: 't' },
    { input: 'у', output: 'u' },
    { input: 'ф', output: 'f' },
    { input: 'х', output: 'kh' },
    { input: 'ц', output: 'ts' },
    { input: 'ч', output: 'ch' },
    { input: 'ш', output: 'sh' },
    { input: 'щ', output: 'shch' },
    { input: 'ъ', output: 'ie' },
    { input: 'ы', output: 'y' },
    { input: 'ь', output: '' },
    { input: 'э', output: 'e' },
    { input: 'ю', output: 'iu' },
    { input: 'я', output: 'ia' },
    { input: 'А', output: 'A' },
    { input: 'Б', output: 'B' },
    { input: 'В', output: 'V' },
    { input: 'Г', output: 'G' },
    { input: 'Д', output: 'D' },
    { input: 'Е', output: 'E' },
    { input: 'Ё', output: 'E' },
    { input: 'Ж', output: 'ZH' },
    { input: 'З', output: 'Z' },
    { input: 'И', output: 'I' },
    { input: 'Й', output: 'I' },
    { input: 'К', output: 'K' },
    { input: 'Л', output: 'L' },
    { input: 'М', output: 'M' },
    { input: 'Н', output: 'N' },
    { input: 'О', output: 'O' },
    { input: 'П', output: 'P' },
    { input: 'Р', output: 'R' },
    { input: 'С', output: 'S' },
    { input: 'Т', output: 'T' },
    { input: 'У', output: 'U' },
    { input: 'Ф', output: 'F' },
    { input: 'Х', output: 'KH' },
    { input: 'Ц', output: 'TS' },
    { input: 'Ч', output: 'CH' },
    { input: 'Ш', output: 'SH' },
    { input: 'Щ', output: 'SHCH' },
    { input: 'Ъ', output: 'IE' },
    { input: 'Ы', output: 'Y' },
    { input: 'Ь', output: '' },
    { input: 'Э', output: 'E' },
    { input: 'Ю', output: 'IU' },
    { input: 'Я', output: 'IA' },
  ];

  private phoneticLastNameRules: TransliterationRule[] = [
    { input: 'а', output: 'a' },
    { input: 'б', output: 'b' },
    { input: 'в', output: 'v' },
    { input: 'г', output: 'g' },
    { input: 'д', output: 'd' },
    { input: 'е', output: 'e' },
    { input: 'ё', output: 'e' },
    { input: 'ж', output: 'zh' },
    { input: 'з', output: 'z' },
    { input: 'и', output: 'i' },
    { input: 'й', output: 'y' },
    { input: 'к', output: 'k' },
    { input: 'л', output: 'l' },
    { input: 'м', output: 'm' },
    { input: 'н', output: 'n' },
    { input: 'о', output: 'o' },
    { input: 'п', output: 'p' },
    { input: 'р', output: 'r' },
    { input: 'с', output: 's' },
    { input: 'т', output: 't' },
    { input: 'у', output: 'u' },
    { input: 'ф', output: 'f' },
    { input: 'х', output: 'kh' },
    { input: 'ц', output: 'ts' },
    { input: 'ч', output: 'ch' },
    { input: 'ш', output: 'sh' },
    { input: 'щ', output: 'shch' },
    { input: 'ъ', output: '' },
    { input: 'ы', output: 'y' },
    { input: 'ь', output: 'i' },
    { input: 'э', output: 'e' },
    { input: 'ю', output: 'yu' },
    { input: 'я', output: 'ya' },
    { input: 'А', output: 'A' },
    { input: 'Б', output: 'B' },
    { input: 'В', output: 'V' },
    { input: 'Г', output: 'G' },
    { input: 'Д', output: 'D' },
    { input: 'Е', output: 'E' },
    { input: 'Ё', output: 'E' },
    { input: 'Ж', output: 'ZH' },
    { input: 'З', output: 'Z' },
    { input: 'И', output: 'I' },
    { input: 'Й', output: 'Y' },
    { input: 'К', output: 'K' },
    { input: 'Л', output: 'L' },
    { input: 'М', output: 'M' },
    { input: 'Н', output: 'N' },
    { input: 'О', output: 'O' },
    { input: 'П', output: 'P' },
    { input: 'Р', output: 'R' },
    { input: 'С', output: 'S' },
    { input: 'Т', output: 'T' },
    { input: 'У', output: 'U' },
    { input: 'Ф', output: 'F' },
    { input: 'Х', output: 'KH' },
    { input: 'Ц', output: 'TS' },
    { input: 'Ч', output: 'CH' },
    { input: 'Ш', output: 'SH' },
    { input: 'Щ', output: 'SHCH' },
    { input: 'Ъ', output: '' },
    { input: 'Ы', output: 'Y' },
    { input: 'Ь', output: 'I' },
    { input: 'Э', output: 'E' },
    { input: 'Ю', output: 'YU' },
    { input: 'Я', output: 'YA' },
    //ия, ья -> ia
    { input: 'ия', output: 'ia' },
    { input: 'ья', output: 'ia' },
    { input: 'ИЯ', output: 'IA' },
    { input: 'ЬЯ', output: 'IA' },
    // мягкий знак на конце или перед согласной отбрасываем
    { input: 'ьб', output: 'b' },
    { input: 'ьв', output: 'v' },
    { input: 'ьг', output: 'g' },
    { input: 'ьд', output: 'd' },
    { input: 'ьж', output: 'zh' },
    { input: 'ьз', output: 'z' },
    { input: 'ьй', output: 'y' },
    { input: 'ьк', output: 'k' },
    { input: 'ьл', output: 'l' },
    { input: 'ьм', output: 'm' },
    { input: 'ьн', output: 'n' },
    { input: 'ьп', output: 'p' },
    { input: 'ьр', output: 'r' },
    { input: 'ьс', output: 's' },
    { input: 'ьт', output: 't' },
    { input: 'ьф', output: 'f' },
    { input: 'ьх', output: 'kh' },
    { input: 'ьц', output: 'ts' },
    { input: 'ьч', output: 'ch' },
    { input: 'ьш', output: 'sh' },
    { input: 'ьщ', output: 'shch' },
    { input: 'ЬБ', output: 'B' },
    { input: 'ЬВ', output: 'V' },
    { input: 'ЬГ', output: 'G' },
    { input: 'ЬД', output: 'D' },
    { input: 'ЬЖ', output: 'ZH' },
    { input: 'ЬЗ', output: 'Z' },
    { input: 'ЬЙ', output: 'Y' },
    { input: 'ЬК', output: 'K' },
    { input: 'ЬЛ', output: 'L' },
    { input: 'ЬМ', output: 'M' },
    { input: 'ЬН', output: 'N' },
    { input: 'ЬО', output: 'O' },
    { input: 'ЬП', output: 'P' },
    { input: 'ЬР', output: 'R' },
    { input: 'ЬС', output: 'S' },
    { input: 'ЬТ', output: 'T' },
    { input: 'ЬФ', output: 'F' },
    { input: 'ЬХ', output: 'KH' },
    { input: 'ЬЦ', output: 'TS' },
    { input: 'ЬЧ', output: 'CH' },
    { input: 'ЬШ', output: 'SH' },
    { input: 'ЬЩ', output: 'SHCH' },
    { input: 'ь ', output: ' ' },
    { input: 'Ь ', output: ' ' },
  ];

  private phoneticFirstNameRules: TransliterationRule[] = [
    { input: 'а', output: 'a' },
    { input: 'б', output: 'b' },
    { input: 'в', output: 'v' },
    { input: 'г', output: 'g' },
    { input: 'д', output: 'd' },
    { input: 'е', output: 'e' },
    { input: 'ё', output: 'e' },
    { input: 'ж', output: 'zh' },
    { input: 'з', output: 'z' },
    { input: 'и', output: 'i' },
    { input: 'й', output: 'y' },
    { input: 'к', output: 'k' },
    { input: 'л', output: 'l' },
    { input: 'м', output: 'm' },
    { input: 'н', output: 'n' },
    { input: 'о', output: 'o' },
    { input: 'п', output: 'p' },
    { input: 'р', output: 'r' },
    { input: 'с', output: 's' },
    { input: 'т', output: 't' },
    { input: 'у', output: 'u' },
    { input: 'ф', output: 'f' },
    { input: 'х', output: 'kh' },
    { input: 'ц', output: 'ts' },
    { input: 'ч', output: 'ch' },
    { input: 'ш', output: 'sh' },
    { input: 'щ', output: 'shch' },
    { input: 'ъ', output: '' },
    { input: 'ы', output: 'y' },
    { input: 'ь', output: 'i' },
    { input: 'э', output: 'e' },
    { input: 'ю', output: 'yu' },
    { input: 'я', output: 'ya' },
    { input: 'А', output: 'A' },
    { input: 'Б', output: 'B' },
    { input: 'В', output: 'V' },
    { input: 'Г', output: 'G' },
    { input: 'Д', output: 'D' },
    { input: 'Е', output: 'E' },
    { input: 'Ё', output: 'E' },
    { input: 'Ж', output: 'ZH' },
    { input: 'З', output: 'Z' },
    { input: 'И', output: 'I' },
    { input: 'Й', output: 'Y' },
    { input: 'К', output: 'K' },
    { input: 'Л', output: 'L' },
    { input: 'М', output: 'M' },
    { input: 'Н', output: 'N' },
    { input: 'О', output: 'O' },
    { input: 'П', output: 'P' },
    { input: 'Р', output: 'R' },
    { input: 'С', output: 'S' },
    { input: 'Т', output: 'T' },
    { input: 'У', output: 'U' },
    { input: 'Ф', output: 'F' },
    { input: 'Х', output: 'KH' },
    { input: 'Ц', output: 'TS' },
    { input: 'Ч', output: 'CH' },
    { input: 'Ш', output: 'SH' },
    { input: 'Щ', output: 'SHCH' },
    { input: 'Ъ', output: '' },
    { input: 'Ы', output: 'Y' },
    { input: 'Ь', output: 'I' },
    { input: 'Э', output: 'E' },
    { input: 'Ю', output: 'YU' },
    { input: 'Я', output: 'YA' },
    //ия, ья -> ia
    { input: 'ия', output: 'ia' },
    { input: 'ья', output: 'ia' },
    { input: 'ИЯ', output: 'IA' },
    { input: 'ЬЯ', output: 'IA' },
    // мягкий знак на конце или перед согласной отбрасываем
    { input: 'ьб', output: 'b' },
    { input: 'ьв', output: 'v' },
    { input: 'ьг', output: 'g' },
    { input: 'ьд', output: 'd' },
    { input: 'ьж', output: 'zh' },
    { input: 'ьз', output: 'z' },
    { input: 'ьй', output: 'y' },
    { input: 'ьк', output: 'k' },
    { input: 'ьл', output: 'l' },
    { input: 'ьм', output: 'm' },
    { input: 'ьн', output: 'n' },
    { input: 'ьп', output: 'p' },
    { input: 'ьр', output: 'r' },
    { input: 'ьс', output: 's' },
    { input: 'ьт', output: 't' },
    { input: 'ьф', output: 'f' },
    { input: 'ьх', output: 'kh' },
    { input: 'ьц', output: 'ts' },
    { input: 'ьч', output: 'ch' },
    { input: 'ьш', output: 'sh' },
    { input: 'ьщ', output: 'shch' },
    { input: 'ЬБ', output: 'B' },
    { input: 'ЬВ', output: 'V' },
    { input: 'ЬГ', output: 'G' },
    { input: 'ЬД', output: 'D' },
    { input: 'ЬЖ', output: 'ZH' },
    { input: 'ЬЗ', output: 'Z' },
    { input: 'ЬЙ', output: 'Y' },
    { input: 'ЬК', output: 'K' },
    { input: 'ЬЛ', output: 'L' },
    { input: 'ЬМ', output: 'M' },
    { input: 'ЬН', output: 'N' },
    { input: 'ЬО', output: 'O' },
    { input: 'ЬП', output: 'P' },
    { input: 'ЬР', output: 'R' },
    { input: 'ЬС', output: 'S' },
    { input: 'ЬТ', output: 'T' },
    { input: 'ЬФ', output: 'F' },
    { input: 'ЬХ', output: 'KH' },
    { input: 'ЬЦ', output: 'TS' },
    { input: 'ЬЧ', output: 'CH' },
    { input: 'ЬШ', output: 'SH' },
    { input: 'ЬЩ', output: 'SHCH' },
    { input: 'ь ', output: ' ' },
    { input: 'Ь ', output: ' ' },
    //ий, ый -> y на конце
    { input: 'ий ', output: 'y ' },
    { input: 'ый ', output: 'y ' },
    { input: 'ИЙ ', output: 'Y ' },
    { input: 'ЫЙ ', output: 'Y ' },
  ];

  public transliterateLastName(input: string | null, method: TransliterationMethod): string {
    return method === TransliterationMethod.IKAO
      ? this.transliterate(input, this.ikaoRules)
      : this.transliterate(input, this.phoneticLastNameRules);
  }

  public transliterateFirstName(input: string | null, method: TransliterationMethod): string {
    return method === TransliterationMethod.IKAO
      ? this.transliterate(input, this.ikaoRules)
      : this.transliterate(input, this.phoneticFirstNameRules);
  }

  private transliterate(name: string | null, rules: TransliterationRule[]): string {
    if (name === null || name === '') return '';

    var input = name + ' ';
    var output = '';
    for (var i = 0; i < input.length; ++i) {
      if (i < input.length - 2) {
        var letters = input[i] + input[i + 1] + input[i + 2];
        var rule = rules.filter((r) => r.input === letters)[0];
        if (rule != undefined) {
          output += rule.output;
          i += 2;
          continue;
        }
      }

      if (i < input.length - 1) {
        var letters = input[i] + input[i + 1];
        var rule = rules.filter((r) => r.input === letters)[0];
        if (rule != undefined) {
          output += rule.output;
          ++i;
          continue;
        }
      }

      var rule = rules.filter((r) => r.input === input[i])[0];
      if (rule != undefined) {
        output += rule.output;
        continue;
      }

      output += input[i];
    }

    if (output.length > 0 && output[output.length - 1] == ' ') {
      output = output.substr(0, output.length - 1);
    }

    return output;
  }
}
